import pinia from '@/store.js';
import { defineStore } from "pinia";

export const useLoadingMsgStore = defineStore('LoadingMsgStore', {
    state: () => ({
        loadingmsg: false,
        offline: false,
    }),
    getters: {
    },
    actions: {
    }
});
